import { PropertyFilterOptions } from "./fetchPropertyFilterOptions";

/**
 * Adapts the structured property filter options API response into the format
 * expected by ActiveFilterComponent's `dynamiceFilterCount` prop.
 *
 * This bridges the new property-scoped API response with the existing
 * search page filter components that expect a flat count structure.
 */
const adaptPropertyFilterOptions = (options: PropertyFilterOptions | null) => {
  if (!options) return null;

  // Build meta_types: merge room_types + accommodation + kitchen + bathroom into one flat map
  const metaTypes: Record<string, number> = {};
  options.room_type?.room_types?.forEach((item) => {
    metaTypes[item.value] = item.count;
  });
  options.room_type?.accommodation?.forEach((item) => {
    metaTypes[item.value] = item.count;
  });
  options.room_type?.kitchen?.forEach((item) => {
    metaTypes[item.value] = item.count;
  });
  options.room_type?.bathroom?.forEach((item) => {
    metaTypes[item.value] = item.count;
  });

  // Build lease_duration: flat list from stay_duration (backend already picks weekly/monthly)
  const leaseDuration: Record<string, number> = {};
  if (options.stay_duration && Array.isArray(options.stay_duration)) {
    (options.stay_duration as any[]).forEach((item: any) => {
      leaseDuration[item.key] = item.count;
    });
  }

  // Build move_in_month: the MoveInMonth component uses dynamiCount?.data?.move_in_month
  // which is a map of "yyyy-MM" → count. Our API returns "mon-yyyy" format.
  // The MoveInMonth component actually checks availability by month, so we pass the data as-is.
  const moveInMonth: Record<string, number> = {};
  if (options.move_in_month && Array.isArray(options.move_in_month)) {
    options.move_in_month.forEach((item) => {
      // Convert "sep-2026" back to "2026-09" format for the existing component
      const [mon, year] = item.value.split("-");
      const monthMap: Record<string, string> = {
        jan: "01",
        feb: "02",
        mar: "03",
        apr: "04",
        may: "05",
        jun: "06",
        jul: "07",
        aug: "08",
        sep: "09",
        oct: "10",
        nov: "11",
        dec: "12",
      };
      const monthNum = monthMap[mon] || "01";
      moveInMonth[`${year}-${monthNum}`] = item.count;
    });
  }

  return {
    meta: { count: 1 }, // Property-scoped, always 1 inventory
    data: {
      meta_types: metaTypes,
      lease_duration: leaseDuration,
      move_in_month: moveInMonth,
      // Dual occupancy is handled separately by the DualOccupancy component
      dual_occupancy: options.dual_occupancy,
    },
  };
};

export default adaptPropertyFilterOptions;
